var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCareIndividual(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 51,
    height: 51,
    viewBox: "0 0 51 51",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M32.6174 37.9393C32.6174 37.9393 31.9932 40.0516 29.8522 39.5271C27.7111 39.0025 22.6404 37.7816 22.6404 37.7816",
    stroke: "#132A3A",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M32.6174 37.9393C32.6174 37.9393 31.9932 40.0516 29.8522 39.5271C27.7111 39.0025 22.6404 37.7816 22.6404 37.7816",
    stroke: "#132A3A",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M30.8798 10.8373C33.5963 10.8373 35.7984 8.63512 35.7984 5.91863C35.7984 3.20215 33.5963 1 30.8798 1C28.1633 1 25.9612 3.20215 25.9612 5.91863C25.9612 8.63512 28.1633 10.8373 30.8798 10.8373Z",
    stroke: "#45B14A",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M32.3079 24.166H38.0208C39.0392 24.166 39.8648 23.3404 39.8648 22.322V18.0227C39.8648 14.0707 36.6313 10.8373 32.6793 10.8373H29.0804C25.1284 10.8373 21.895 14.0707 21.895 18.0227V22.3219C21.895 23.3404 22.7205 24.1659 23.739 24.1659H28.8571M10.1623 46.8364L13.773 45.4656C16.3569 44.6234 19.0657 44.5382 21.2352 45.404L25.8424 47.2432C26.8494 47.5904 29.1629 48.1308 31.5635 46.9003L31.5655 46.8994L36.38 44.7697L39.536 43.3738L47.6493 39.785C48.1363 39.5353 50.585 38.0661 49.4879 35.5717C48.2162 32.9162 45.2895 34.1714 45.0437 34.2633L32.6178 37.9395C32.6178 37.9395 33.4685 35.4402 30.8925 34.4121C23.7533 31.5621 22.9019 31.0802 21.0951 31.0515L21.0949 31.0513C15.5097 31.0699 14.4977 31.1155 11.722 32.3578C10.2757 33.0059 8.8949 33.7913 7.5987 34.7033C6.75337 35.2976 5.81536 35.7475 4.81909 36.0215L1.42859 36.9537C1.23871 37.006 1.07122 37.1191 0.951854 37.2757C0.832484 37.4323 0.76783 37.6238 0.767822 37.8207V49.1C0.767822 49.7293 1.39773 50.164 1.98613 49.9406L6.93626 48.0612",
    stroke: "#132A3A",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCareIndividual);
export default __webpack_public_path__ + "static/media/careIndividual.c32b3c0c483e89aebc6a7e9701d55531.svg";
export { ForwardRef as ReactComponent };